import { Component } from '@angular/core';

@Component({
  selector: 'cx-store-finder-page',
  templateUrl: './store-finder-page.component.html',
  styleUrls: ['./store-finder-page.component.scss']
})
export class StoreFinderPageComponent {
  constructor() {}
}
